import classNames from 'classnames/bind';
import { Panel } from 'components/Panel';
import { i18nKeys, useTranslation } from 'locales';
import { languageName } from 'types';
import type { Debtor } from 'types/store/client-state';

import styleIdentifiers from './debtorAdditionalInfo.module.scss';

const styles = classNames.bind(styleIdentifiers);

type Props = {
  clientData: Debtor;
};

export default function DebtorAdditionalInfo({ clientData }: Props) {
  const { t } = useTranslation();

  return (
    <Panel title={t(i18nKeys.DETAILS)} className={styles('box', 'client-info', 'className')}>
      <div className={styles('item', 'block')}>
        <span className={styles('subtitle')}>{t(i18nKeys.CLIENT.EXTERNAL_ID)}</span>
        <div className={styles('value', 'medium')}>{clientData.csv_id}</div>
      </div>
      <div className={styles('item', 'block')}>
        <span className={styles('subtitle')}>{t(i18nKeys.VAT_NUMBER)}</span>
        <div className={styles('value', 'medium')}>{clientData.vat_number}</div>
      </div>
      <div className={styles('item', 'block')}>
        <span className={styles('subtitle')}>{t(i18nKeys.RECOVERY_PLAN)}</span>
        <div className={styles('value', 'medium')}>{clientData.recovery_plan?.name}</div>
      </div>
      <div className={styles('item', 'block')}>
        <span className={styles('subtitle')}>{t(i18nKeys.DEBTOR.LOCALE)}</span>
        <div className={styles('value', 'medium')}>
          {clientData.locale ? languageName(clientData.locale) : 'N/A'}
        </div>
      </div>
      <div className={styles('item', 'block')}>
        <span className={styles('subtitle')}>{t(i18nKeys.DEBTOR.CURRENCY)}</span>
        <div className={styles('value', 'medium')}>{clientData.currency}</div>
      </div>

      <div className={styles('item', 'block')}>
        <span className={styles('subtitle')}>{t(i18nKeys.COMMON.BANK_ACCOUNT)}</span>
        <div className={styles('value', 'medium')}>
          {clientData.debtor_bank_accounts_attributes[0]?.iban}
        </div>
      </div>
    </Panel>
  );
}
